import React, { Component } from "react";
import "../ClientTable.css"; // Создадим отдельный CSS файл

class ClientTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      sortField: null,
      sortDirection: "asc",
      currentPage: 1,
      itemsPerPage: 10,
    };
  }

  // Поиск по всем полям
  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 });
  };

  // Сортировка
  handleSort = (field) => {
    const { sortField, sortDirection } = this.state;
    
    if (sortField === field) {
      // Меняем направление сортировки
      this.setState({
        sortDirection: sortDirection === "asc" ? "desc" : "asc",
      });
    } else {
      // Новое поле для сортировки
      this.setState({
        sortField: field,
        sortDirection: "asc",
      });
    }
  };

  // Фильтрация данных
  getFilteredData = () => {
    const { data } = this.props;
    const { searchTerm, sortField, sortDirection } = this.state;

    let filtered = [...data];

    // Поиск
    if (searchTerm) {
      filtered = filtered.filter((item) => {
        return Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }

    // Сортировка
    if (sortField) {
      filtered.sort((a, b) => {
        const aVal = a[sortField] || "";
        const bVal = b[sortField] || "";

        if (sortDirection === "asc") {
          return aVal > bVal ? 1 : -1;
        } else {
          return aVal < bVal ? 1 : -1;
        }
      });
    }

    return filtered;
  };

  // Пагинация
  getPaginatedData = () => {
    const { currentPage, itemsPerPage } = this.state;
    const filtered = this.getFilteredData();
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return filtered.slice(start, end);
  };

  getTotalPages = () => {
    const { itemsPerPage } = this.state;
    const filtered = this.getFilteredData();
    return Math.ceil(filtered.length / itemsPerPage);
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  // Форматирование значений
  formatValue = (value, field) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    // Форматирование даты
    if (field === "user_registered_at" || field === "created_at") {
      return new Date(value).toLocaleString("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    // Форматирование булевых значений
    if (typeof value === "boolean") {
      return value ? (
        <span className="badge badge-success">Да</span>
      ) : (
        <span className="badge badge-secondary">Нет</span>
      );
    }

    return value;
  };

  render() {
    const { columns, title, onView } = this.props;
    const { searchTerm, sortField, sortDirection, currentPage } = this.state;
    
    const paginatedData = this.getPaginatedData();
    const totalPages = this.getTotalPages();
    const filteredCount = this.getFilteredData().length;

    return (
      <div className="client-table-container">
        {/* Заголовок и поиск */}
        <div className="table-header">
          <h3>{title || "Таблица"}</h3>
          <div className="table-controls">
            <input
              type="text"
              className="form-control search-input"
              placeholder="Поиск..."
              value={searchTerm}
              onChange={this.handleSearch}
            />
          </div>
        </div>

        {/* Информация о результатах */}
        <div className="table-info">
          Найдено записей: <strong>{filteredCount}</strong>
        </div>

        {/* Таблица */}
        <div className="table-responsive">
          <table className="table table-hover table-bordered">
            <thead className="thead-light">
              <tr>
                {columns.map((col) => (
                  <th
                    key={col.field}
                    onClick={() => this.handleSort(col.field)}
                    className="sortable-header"
                  >
                    {col.header}
                    {sortField === col.field && (
                      <span className="sort-icon">
                        {sortDirection === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                ))}
                {/* {(onEdit || onDelete || onView) && (
                  <th className="actions-column">Действия</th>
                )} */}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row, index) => (
                  <tr key={row.id || index}>
                    {columns.map((col) => (
                      <td key={col.field}>
                        {this.formatValue(row[col.field], col.field)}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    className="text-center"
                  >
                    Нет данных для отображения
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Пагинация */}
        {totalPages > 1 && (
          <div className="pagination-container">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Назад
                  </button>
                </li>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  // Показываем только 5 страниц вокруг текущей
                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= currentPage - 2 && page <= currentPage + 2)
                  ) {
                    return (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => this.handlePageChange(page)}
                        >
                          {page}
                        </button>
                      </li>
                    );
                  } else if (
                    page === currentPage - 3 ||
                    page === currentPage + 3
                  ) {
                    return (
                      <li key={page} className="page-item disabled">
                        <span className="page-link">...</span>
                      </li>
                    );
                  }
                  return null;
                })}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Вперёд
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    );
  }
}

export default ClientTable;